import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'
import { SecureRoute } from '@okta/okta-react'
import NotFoundView from '../common/NotFoundView'
import SchedulesHome from './Home'
import NewSchedule from './NewSchedule'
import ScheduleDetail from './ScheduleDetail'
import EditSchedule from './EditSchedule'
import NewDigest from './NewDigest'

function Schedules () {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <SecureRoute path={`${path}`} exact>
        <SchedulesHome />
      </SecureRoute>
      <SecureRoute path={`${path}/new`} exact>
        <NewSchedule />
      </SecureRoute>
      <SecureRoute path={`${path}/new-schedule`} exact>
        <NewSchedule />
      </SecureRoute>
      <SecureRoute path={`${path}/new-digest`} exact>
        <NewDigest />
      </SecureRoute>
      <SecureRoute path={`${path}/:scheduleId`} exact>
        <ScheduleDetail />
      </SecureRoute>
      <SecureRoute path={`${path}/:scheduleId/edit`} exact>
        <EditSchedule />
      </SecureRoute>
      <SecureRoute path='*'>
        <NotFoundView />
      </SecureRoute>
    </Switch>
  )
}

export default Schedules
